import React from 'react';

import { SubItemsSection } from './components/sub-items-section';

export const Tasks: React.FC = () => {
  return <SubItemsSection fullSize />;
};
